module.exports = __webpack_public_path__ + "static/img/s65.218b0e28.png";